
import React from 'react';
import { CardFooter } from '@/components/ui/card';

interface AuthFooterProps {
  authMode: 'login' | 'signup' | 'admin';
  onModeChange: (mode: 'login' | 'signup') => void;
}

const AuthFooter: React.FC<AuthFooterProps> = ({ authMode, onModeChange }) => {
  const getText = () => {
    switch (authMode) {
      case 'login':
        return "Don't have an account? ";
      case 'signup':
        return "Already have an account? ";
      case 'admin':
        return "Not an administrator? ";
      default:
        return "";
    }
  };

  const getLinkText = () => {
    switch (authMode) {
      case 'login':
        return 'Sign up here';
      case 'signup':
        return 'Sign in here';
      case 'admin':
        return 'Return to login';
      default:
        return '';
    }
  };

  const handleClick = () => {
    if (authMode === 'login') {
      onModeChange('signup');
    } else {
      onModeChange('login');
    }
  };

  return (
    <CardFooter className="justify-center flex-col">
      <p className="text-sm text-gray-500 text-center">
        {getText()}
        <button
          type="button"
          onClick={handleClick}
          className="text-green-600 hover:underline"
        >
          {getLinkText()}
        </button>
      </p>
    </CardFooter>
  );
};

export default AuthFooter;
